module.exports = __webpack_public_path__ + "img/class4.59ffd49d.png";